import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFile from '../Shared/ChunkedUploadFile';
import './AdministrativeUploadFile.css';

const ADMINISTRATIVE_ROOT =
  process.env.REACT_APP_ADMIN_START_PATH || '/administrative';

function AdministrativeUploadFile({ currentPath, userId, onFileUploaded }) {
  return (
    <ChunkedUploadFile
      currentPath={currentPath}
      userId={userId}
      onFileUploaded={onFileUploaded}
      rootPath={ADMINISTRATIVE_ROOT}
      sessionPrefix="administrative_file"
    />
  );
}

AdministrativeUploadFile.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFileUploaded: PropTypes.func,
};

export default AdministrativeUploadFile;
